import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ParentProductFilters from "./parent-product-filters";
import {searchParentProducts, updateParentProducts} from "../../services/parent-product-data-service";
import {
    PARENT_PRODUCT_FIELD_LIST,
    PRODUCT_DETAIL_KEY,
    PRODUCT_SIZE_FILTER_LIST,
    SAVE_POD_TIME_DELAY, SELECT_PARENT_PRODUCT_FIELD_LIST
} from "../../constants/pod.constant";
import {convertInchToPixel} from "../../utils/dimension-util";

const parentProductFields: any = SELECT_PARENT_PRODUCT_FIELD_LIST;

const SelectParentProductList = ({
                                     podDetail,
                                     selectedParentProductList,
                                     setSelectedParentProductList,
                                     filterCriteria, setFilterCriteria,
                                     tableClassName = 'table-container'
                                 }) => {
    const [initialStep, setInitialStep] = useState(true);
    const [enableEdit, setEnableEdit] = useState(false);
    const [parentProductList, setParentProductList] = useState(null);
    const [updatedParentProductsMap, setUpdatedParentProductsMap] = useState(null);
    let [changesCount, setChangesCount] = useState(0);
    const [selectedParentProductIdList, setSelectedParentProductIdList] = useState(_.map(selectedParentProductList, 'id'));

    useEffect(() => {
        if (initialStep) {
            searchParentProductList();
        }
    }, [initialStep]);

    const searchParentProductList = async () => {
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'podId', condition: '==', value: podDetail?.id});

        _.forIn(filterCriteria, (value, field) => {
            if (!_.isEmpty(value)) {
                searchCriteriaList.push({field: field, condition: '==', value: value});
            }
        });

        const existingParentProducts = await searchParentProducts(searchCriteriaList);
        setParentProductList(_.orderBy(existingParentProducts, ['productType', 'category', 'name']));
    }

    const handleDetailChanges = (event, rowIndex, parentProduct) => {
        const {name, value} = event.target;
        parentProduct[name] = value;

        if (name === PRODUCT_DETAIL_KEY.HEIGHT_INCH) {
            parentProduct[PRODUCT_DETAIL_KEY.HEIGHT_PIXEL] = convertInchToPixel(value);
        } else if (name === PRODUCT_DETAIL_KEY.WIDTH_INCH) {
            parentProduct[PRODUCT_DETAIL_KEY.WIDTH_PIXEL] = convertInchToPixel(value);
        } else if (name === PRODUCT_DETAIL_KEY.SIZE_TYPE) {
            parentProduct.isMultiMeasurement = (value === 'multi-measurements');
        }

        const tempUpdatedParentProductsMap = {...updatedParentProductsMap};
        tempUpdatedParentProductsMap[rowIndex] = parentProduct;
        setUpdatedParentProductsMap(tempUpdatedParentProductsMap);
    }

    useEffect(() => {
        incrementChangesCount();
    }, [updatedParentProductsMap]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    saveUpdatedParentProducts();
                }

            }, SAVE_POD_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const saveUpdatedParentProducts = async () => {
        const tempUpdatedParentProductsMap = {...updatedParentProductsMap};
        const updateParentProductList = _.values(tempUpdatedParentProductsMap);

        if (!_.isEmpty(updateParentProductList)) {
            await updateParentProducts(updateParentProductList);
        }
    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    const toggleParentProductSelection = (parentProduct) => {
        let existingParentProductIdList = [...selectedParentProductIdList];
        let existingParentProductList = [...selectedParentProductList];

        if (existingParentProductIdList?.indexOf(parentProduct?.id) === -1) {
            existingParentProductIdList.push(parentProduct?.id);
            existingParentProductList.push(parentProduct);
        } else {
            existingParentProductIdList = _.remove(existingParentProductIdList, function (existingParentProductId) {
                return existingParentProductId !== parentProduct?.id;
            });

            existingParentProductList = _.remove(existingParentProductList, function (existingParentProduct) {
                return existingParentProduct?.id !== parentProduct?.id;
            });
        }

        setSelectedParentProductIdList(existingParentProductIdList);
        setSelectedParentProductList(existingParentProductList);
    }

    const selectAllParentProducts = () => {
        let existingParentProductIdList = [...selectedParentProductIdList];
        let existingParentProductList = [...selectedParentProductList];

        _.forEach(parentProductList, parentProduct => {
            if (existingParentProductIdList?.indexOf(parentProduct?.id) === -1) {
                existingParentProductIdList.push(parentProduct?.id);
                existingParentProductList.push(parentProduct);
            }
        })

        setSelectedParentProductIdList(existingParentProductIdList);
        setSelectedParentProductList(existingParentProductList);
    }

    const removeAllParentProducts = () => {
        setSelectedParentProductIdList([]);
        setSelectedParentProductList([]);
    }

    return (
        <>

            {podDetail &&

                <>

                    <div className="flex justify-start">

                        <div className='w-3/5'>
                            <div className="-ml-2 mb-4">
                                <ParentProductFilters
                                    searchProductsList={searchParentProductList}
                                    enableEdit={enableEdit}
                                    setEnableEdit={setEnableEdit}
                                    filterCriteria={filterCriteria}
                                    setFilterCriteria={setFilterCriteria}
                                    podDetail={podDetail}/>
                            </div>

                            <div className={`${tableClassName} overflow-y-scroll border-y border-gray-400 bg-white`}>
                                <table className="w-full">
                                    <thead className="">
                                    <tr>
                                        <th className="px-2 pb-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                        <th className="px-2 pb-2 items-center border border-gray-400 sticky top-0 bg-gray-400">
                                            {!selectedParentProductIdList &&
                                                <div>Select</div>
                                            }

                                            {selectedParentProductIdList &&
                                                <div className="flex justify-center">
                                                    <button onClick={selectAllParentProducts}
                                                            className="mt-2 button-green-outline py-1 px-4">
                                                        Select All
                                                    </button>
                                                </div>
                                            }
                                        </th>


                                        {parentProductFields?.map((field, rowIndex) => (
                                            <React.Fragment key={`th-${rowIndex}`}>
                                                {!field?.hideInList &&
                                                    <th className="px-2 py-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">{field?.label}</th>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody className="">
                                    {parentProductList?.map((parentProduct, rowIndex) => (
                                        <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                            <td className="p-2 border border-gray-400 m-auto">
                                                {rowIndex + 1}
                                            </td>

                                            <td className="w-48 p-2 border-r border-gray-400">
                                                <div className="flex justify-center">
                                                    {selectedParentProductIdList?.indexOf(parentProduct?.id) === -1 &&
                                                        <button
                                                            className="button-small py-1"
                                                            onClick={() => toggleParentProductSelection(parentProduct)}>
                                                            Select
                                                        </button>
                                                    }

                                                    {selectedParentProductIdList?.indexOf(parentProduct?.id) !== -1 &&
                                                        <button
                                                            className="button-small button-green py-1"
                                                            onClick={() => toggleParentProductSelection(parentProduct)}>
                                                            Selected
                                                        </button>
                                                    }
                                                </div>
                                            </td>

                                            {parentProductFields?.map((field, columnIndex) => (
                                                <React.Fragment key={`row-${rowIndex}-column-${columnIndex}`}>
                                                    {!field?.hideInList &&
                                                        <td key={`column-${rowIndex}-${columnIndex}`}
                                                            className={`p-2 border border-gray-400 ${field?.isEditable && enableEdit ? 'bg-gray-200' : ''} ${(field?.attribute === 'colors' || field?.attribute === 'name') ? 'w-1/4' : ''}`}>
                                                            {!(field?.isEditable && enableEdit) &&
                                                                <>
                                                                    {!field?.isList &&
                                                                        <>{parentProduct[field.attribute]}</>
                                                                    }

                                                                    {field?.isList &&
                                                                        <>
                                                                            {parentProduct[field.attribute]?.map((item, itemIndex) => (
                                                                                <React.Fragment
                                                                                    key={`row-${rowIndex}-column-${columnIndex}-item-${itemIndex}`}>{item.name}, </React.Fragment>
                                                                            ))}
                                                                        </>
                                                                    }
                                                                </>
                                                            }

                                                            {field?.isEditable && enableEdit &&
                                                                <>
                                                                    <input
                                                                        type="number"
                                                                        className="input-field w-36"
                                                                        id={field.attribute}
                                                                        name={field.attribute}
                                                                        value={parentProduct[field.attribute] || ''}
                                                                        onChange={(event) => {
                                                                            handleDetailChanges(event, rowIndex, parentProduct);
                                                                        }}>
                                                                    </input>
                                                                </>
                                                            }
                                                        </td>
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </tr>

                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className='w-2/5 ml-6'>
                            <div className="mb-4 text-xl">
                                Selected Parent Products
                            </div>

                            <div
                                className={`selected-products-table-container overflow-y-scroll border border-gray-400 bg-gray-100 p-4`}>
                                <table className="w-full">
                                    <thead className="">
                                    <tr>
                                        <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">S.No</th>
                                        <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                                            Product Type/ Category
                                        </th>
                                        <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                                            Parent Product
                                        </th>
                                        <th className="p-2 border border-gray-400 sticky top-0 bg-gray-400 text-white">
                                            <button onClick={removeAllParentProducts}
                                                    className="button-red-outline py-1 px-4">
                                                Remove All
                                            </button>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="">
                                    {selectedParentProductList?.map((parentProduct, rowIndex) => (

                                        <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                            <td className="p-2 border border-gray-400 m-auto">
                                                {rowIndex + 1}
                                            </td>

                                            <td className="p-2 border-r border-gray-400">
                                                {parentProduct?.productType} / {parentProduct?.category}
                                            </td>

                                            <td className="p-2 border-r border-gray-400">
                                                {parentProduct?.name}
                                            </td>

                                            <td className="p-2 border-r border-gray-400">
                                                <div className="flex justify-center">
                                                    <button
                                                        className="button-small button-red-outline py-1"
                                                        onClick={() => toggleParentProductSelection(parentProduct)}>
                                                        Remove
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>

                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </>

            }

        </>
    )
}

export default SelectParentProductList
